import Main from './Main'
import Edit from './Edit'
import Create from './Create'

export default {
  Main,
  Edit,
  Create
}



// WEBPACK FOOTER //
// ./src/components/User/Group/index.js